<div class="app-user" [dir]="direction">
  <a
    nz-dropdown
    nzPlacement="bottomRight"
    nzTrigger="click"
    [(nzVisible)]="dropdownVisible"
    (nzVisibleChange)="dropdownVisibleChange($event)"
    [nzDropdownMenu]="userMenu"
    data-cy="user-menu"
  >
    @if (userTitleVisible) {
    <span class="app-user-title">{{ userTitle }}</span>
    }
    <div class="app-user-avatar">
      <app-avatar [text]="userFullName" [size]="'32px'"></app-avatar>
      <i nz-icon nzType="images:dropgreen"></i>
    </div>
  </a>

  <nz-dropdown-menu #userMenu="nzDropdownMenu">
    @if (dropdownVisible) {
    <app-user-menu-items (itemClicked)="dropdownItemClicked()"></app-user-menu-items>
    }
  </nz-dropdown-menu>
</div>
